<template>
  <div v-if="dataReady" class="mt4 black">
    <input :checked="twoYearsUpfront" class="normal" type="checkbox"
           v-on:change="(e) => onChange(e)"/>
    <b><strong>Pay 2 years upfront and save ${{ twoYearDiscount }} more!</strong></b>
    <br/><br/>
  </div>
</template>

<script>
import {TWO_YEAR_UPFRONT_KEY} from '@/constants/registration/discountKeys'
import {
  GET_INTERNAL_DISCOUNT_VALUES,
  GET_TWO_YEARS_UPFRONT,
  REQUEST_INTERNAL_DISCOUNT_VALUES,
  SET_REGISTRATION_DISCOUNTS_ADD,
  SET_REGISTRATION_DISCOUNTS_REMOVE,
  SET_TWO_YEARS_UPFRONT
} from '@/store/registrationv2'
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: 'ak-two-year-upfront-button',
  props: {
    annualValue: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      dataReady: false
    }
  },
  computed: {
    ...mapGetters({
      twoYearsUpfront: GET_TWO_YEARS_UPFRONT,
      internalDiscountValues: GET_INTERNAL_DISCOUNT_VALUES
    }),
    twoYearDiscount () {
      const twoYearDiscount = this.internalDiscountValues[TWO_YEAR_UPFRONT_KEY]
      if (!twoYearDiscount) return ''
      if (twoYearDiscount.amount_type === 'PERCENT') return (this.annualValue * (twoYearDiscount.amount / 100)).toFixed(2)
      return twoYearDiscount.amount.toFixed(2)
    }
  },
  async mounted () {
    await this.requestInternalDiscountValues()
    this.dataReady = true
    if (this.twoYearsUpfront) this.addDiscount(this.internalDiscountValues[TWO_YEAR_UPFRONT_KEY])
  },
  methods: {
    onChange (event) {
      this.setTwoYearsUpfront(event.target.checked)
      const updateDiscount = event.target.checked ? this.addDiscount : this.removeDiscount
      const twoYearUpfrontDiscount = this.internalDiscountValues[TWO_YEAR_UPFRONT_KEY]
      updateDiscount(twoYearUpfrontDiscount)
    },
    ...mapMutations({
      setTwoYearsUpfront: SET_TWO_YEARS_UPFRONT,
      addDiscount: SET_REGISTRATION_DISCOUNTS_ADD,
      removeDiscount: SET_REGISTRATION_DISCOUNTS_REMOVE
    }),
    ...mapActions({
      requestInternalDiscountValues: REQUEST_INTERNAL_DISCOUNT_VALUES
    })
  }
}
</script>



// WEBPACK FOOTER //
// TwoYearsUpFrontButton.vue?a7d366e8